import { Component, h } from '@stencil/core';

@Component({
  tag: 'uui-base-theme',
  shadow: true,
  styleUrl: '../../global/base-styles.scss'
})
export class UuiBaseThemeProvider {
  render() {
    const css = UuiBaseThemeProvider['style'];
    return (
      <uui-theme-provider name="base-styles" global={true}>
        <style>{css}</style>
      </uui-theme-provider>
    );
  }
}
